export const toastOptions = {
    position: 'top-right',
    duration: 5000,
}